import { SxProps, Theme } from '@mui/material/styles';

export const useSignUpFormStyles = (theme: Theme): Record<string, SxProps<Theme>> => {
  const isDarkTheme = theme.palette.mode === 'dark';

  return {
    checkbox: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      color: isDarkTheme ? theme.palette.text.secondary : undefined,
    },
    textField: {
      '& .MuiInputBase-input': {
        color: isDarkTheme ? theme.palette.common.white : theme.palette.text.primary,
      },
      '& .MuiInputLabel-root': {
        color: isDarkTheme ? theme.palette.common.white : theme.palette.text.primary,
      },
      '& .MuiFormHelperText-root': {
        color: theme.palette.text.secondary,
      },
    },
    linkText: {
      color: isDarkTheme ? theme.palette.primary.light : theme.palette.primary.main,
    },
    formText: {
      color: isDarkTheme ? theme.palette.common.white : theme.palette.text.primary,
    },
  };
};
